import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var resetConnectGmailStore = mutatorAction('resetConnectGmailStore', function () {
    var store = connectedAccountsStore();
    store.connectGmailState.isConnecting = false;
    store.connectGmailState.displayName = '';
    store.connectGmailState.isSendOnly = false;
    store.connectGmailState.targetRootFolderEnabled = true;
});
//# sourceMappingURL=resetConnectGmailStore.js.map